import { createContext, useContext } from "react";
import type { AudioCaptureActionsContextValue } from "./audio-capture-actions.types";

const AudioCaptureActionsContext = createContext<AudioCaptureActionsContextValue | null>(null);

export const AudioCaptureActionsContextProvider = AudioCaptureActionsContext.Provider;

export function useAudioCaptureActionsContext(): AudioCaptureActionsContextValue {
  const context = useContext(AudioCaptureActionsContext);
  if (!context) {
    throw new Error(
      "useAudioCaptureActionsContext must be used within an AudioCaptureActionsProvider"
    );
  }
  return context;
}
